import React from 'react';

function TopBox(props) {
  const { children } = props;
  return (
    <div className='result-top-menu' id="result-top-menu-id">{children}</div>
  )
}

export default TopBox;